/**
 * The Store Portal's active store, read by the API client for `X-Store-Id` on
 * every request (EP10-S02) and written only by the store scope. Its own module
 * so the client and the scope do not import each other.
 */
export const activeStore: { current: string | null } = { current: null };
